// Registers the CU launcher theme for AntD's STATIC holders (Modal.confirm,
// message, notification), which render OUTSIDE the App's ConfigProvider tree.
//
// Supported antd 6.6.2 API (verified in node_modules/antd/es/config-provider/index.js:
// `ConfigProvider.config = setGlobalConfig` accepts { holderRender }, and the
// static holders render through `globalConfig().holderRender`). Wrapping the
// holder children in a ConfigProvider with the app theme gives the static
// surfaces the exact same CU tokens as the mounted app.
//
// Called ONCE from src/index.js BEFORE any root render. Idempotent.

import { ConfigProvider } from "antd";
import antdTheme from "./antdTheme";

let registered = false;

export const registerStaticTheme = () => {
	if (registered) {
		return;
	}
	ConfigProvider.config({
		holderRender: children => <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>,
	});
	registered = true;
};
